import styled from 'styled-components'

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  
  label.title {
    div {
      font-size: 16px !important;
      font-weight: bold;
    }
  }
`

export const HeaderWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
margin-top: 15px;
gap: 50px;
`

export const TitleSection = styled.div`
  background-color: #D2691E;
  border-radius: 7px;
  width: 40%;
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  min-height: 40px;
  display: flex;
  align-items: center;
`

export const InfoSection = styled.div`
  background-color: #ADD8E6;
  border-radius: 7px;
  width: 100%;
  color: rgb(0, 111, 165) !important;
  font-weight: bold;
  padding: 12px 20px;
  font-size: 14px;
  text-align: center;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContentSection = styled.div`
  padding: 40px 20px 20px 20px;
  background-color: white;
  min-height: 400px;
`
